import { render } from "./CallIcon1.vue?vue&type=template&id=234cda6d"
import script from "./CallIcon1.vue?vue&type=script&lang=js"
export * from "./CallIcon1.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__